import TaxPayer from "app/pages/taxPayers/models/TaxPayer";
import TaxPayerMarket from "app/pages/taxPayers/models/TaxPayerMarket";
import TaxPayerZone from "app/pages/taxPayers/models/TaxPayerZone";
import { withStatus, withTimesTamps } from "app/pages/receipts/models/commons";
import { formatCurrency } from "cofa/utils/functions/text";

class PenaltyDepositReceipt {
  ref;
  documentDate;
  documentRef;
  documentType;
  label;
  reason;
  type;
  plate;
  taxPayer;
  taxPayerRef;
  taxPayerMarket;
  taxPayerZone;
  taxPayerMarketRef;
  taxPayerZoneRef;
  amount;
  paymentDate;
  agentId;
  agentName;
  agentDepositDate;
  agentDepositRef;
  cashierId;
  cashierName;
  cashierDepositDate;
  canceledAt;
  canceledBy;
  cancelReason;
  canceledByName;
  longitude;
  latitude;
  status;
  searchSlug;
  paymentMode;

  constructor(receipt) {
    Object.assign(this, receipt);
  }

  static fromJson(receipt) {
    return new PenaltyDepositReceipt({
      ref: receipt["ref"],

      documentDate: receipt["document_date"],
      documentRef: receipt["document_ref"],
      documentType: receipt["document_type"],

      label: receipt["label"],
      reason: receipt["reason"],
      type: receipt["type"],
      plate: receipt["plate"],

      taxPayerRef: receipt["tax_payer_ref"],
      taxPayerMarket:
        receipt["tax_payer_market"] &&
        TaxPayerMarket.fromJson(receipt["tax_payer_market"]),
      taxPayerZone:
        receipt["tax_payer_zone"] &&
        TaxPayerZone.fromJson(receipt["tax_payer_zone"]),
      taxPayerMarketRef: receipt["tax_payer_market_ref"],
      taxPayerZoneRef: receipt["tax_payer_zone_ref"],

      amount: receipt["amount"],
      paymentDate: receipt["payment_date"],

      agentId: receipt["agent_id"],
      agentName: receipt["agent_name"],
      agentDepositDate: receipt["agent_deposit_date"],
      agentDepositRef: receipt["agent_deposit_ref"],

      deposed: !!receipt["agent_deposit_date"],
      collected: !!receipt["agent_deposit_date"],

      cashierId: receipt["cashier_id"],
      cashierName: receipt["cashier_name"],
      cashierDepositDate: receipt["cashier_deposit_date"],

      canceled: !!receipt["canceled_at"],
      notCanceled: !receipt["canceled_at"],
      canceledAt: receipt["canceled_at"],
      cancelReason: receipt["cancel_reason"],
      canceledBy: receipt["canceled_by_id"],
      canceledByName: receipt["canceled_by_name"],

      longitude: receipt["longitude"],
      latitude: receipt["latitude"],

      taxPayer: receipt["tax_payer"] && TaxPayer.fromJson(receipt["tax_payer"]),

      ...withTimesTamps(receipt),
      ...withStatus(receipt),
    });
  }

  getLabelFr(modes) {
    return (
      modes.find((mode) => mode.code === this.paymentMode)?.label ??
      this.paymentMode
    );
  }

  getSearchSlug(additionalValues = []) {
    return [
      ...additionalValues,
      this.ref,
      this.taxPayer?.ref,
      this.taxPayer?.address,
      this.taxPayer?.phone,
      this.taxPayer?.nif,
      this.taxPayer?.address,
      this.taxPayer?.firstName,
      this.taxPayer?.lastName,
      this.amount,
      formatCurrency(this.amount),
      this.documentRef,
      this.documentType,
      this.label,
      this.reason,
      this.type,
      this.plate,
      this.taxPayerRef,
      this.taxPayerMarketRef,
      this.taxPayerZoneRef,
      this.paymentMode,
      this.agentId,
      this.agentName,
      this.agentDepositDate,
      this.agentDepositRef,
      this.status,
      this.cashierId,
      this.cashierName,
      this.cashierDepositDate,
      this.canceledBy,
      this.cancelReason,
      this.canceledByName,
    ].join("");
  }

  populateWithData({ paymentModes = [] }) {
    //Translate Payment mode to French.
    this.paymentModeFr = this.getLabelFr(paymentModes);

    //Generate search slug that easier search.
    this.searchSlug = this.getSearchSlug([this.paymentModeFr]);

    //Use this method in fluent mode.
    return this;
  }

  asCanceled() {
    this.amount = -1 * this.amount;
    this.canceled = true;

    return this;
  }

  removeCanceledState() {
    this.canceled = false;

    this.canceledAt = null;
    this.canceledBy = null;
    this.canceledByName = null;
    this.cancelReason = null;

    return this;
  }
}

export default PenaltyDepositReceipt;
